// eslint-disable-next-line import/no-cycle
import TabGroup from './TabGroup';

export default TabGroup;
